///////////////////
//
///////////////////
import { OnInit, Component, Injector, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AuthenticationService } from "../../../core/auth/authentication.service";
import { Observable } from "rxjs/Observable";
import { CustomAuthorizationService } from "../../../core/auth/custom-authorization.service";
import { ScreenSizeService } from "../../services/screen-size.service";

@Component({
    selector: "djiv-login-form",
    templateUrl: "./djiv-login-form.component.html",
    styleUrls: ["./djiv-login-form.component.css"],
})
export class DJIVLoginForm implements OnInit {
    public $loginForm: FormGroup;
    public $loginError: string;
    public $dataProviders = "";
    public isMobile: boolean = false;
    protected $router: Router;
    protected $authenticationService: AuthenticationService;
    private screenSizeService: ScreenSizeService;

    constructor(
        protected $injector: Injector,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService
    ) {
        this.$router = $injector.get(Router);
        this.$authenticationService = $injector.get(AuthenticationService);
        this.screenSizeService = $injector.get(ScreenSizeService);
        const signInState = this.$authenticationService.getSigninState();

        if (signInState) {
            this.$dataProviders = signInState.dataProviders.join(", ");
        }

        this.$loginForm = new FormGroup({
            userName: new FormControl("", Validators.required),
            password: new FormControl("", Validators.required),
        });
    }

    ngOnInit(): void {
        this.isMobile = this.screenSizeService.isMobile;
        this.screenSizeService.isMobile$.subscribe(
            (response) => (this.isMobile = response)
        );
    }

    public login() {
        const { userName, password } = this.$loginForm.value;

        this.customAuthorizationService.cleanAuthorizationData();
        this.$authenticationService.signIn({ userName, password }).subscribe(
            () => {
                let onLoginResult;
                onLoginResult = this["onLogin"]({ userName });

                if (onLoginResult instanceof Observable) {
                    onLoginResult.subscribe(() => {
                        this.$router.navigate(["auth-callback"]);
                    });
                } else {
                    this.$router.navigate(["auth-callback"]);
                }
            },
            (error) => {
                this.$loginError = "Invalid credentials";
            }
        );
    }

    //   //fired when the user clicks the password icon fa-eye
    public OnShowHide(): void {
        var type = document.getElementById("password").getAttribute("type");

        if (type == "password") {
            //Change type attribute
            document.getElementById("password").setAttribute("type", "text");
            document
                .getElementById("pass-status")
                .setAttribute("class", "fa fa-eye-slash");
        } else {
            //Change type attribute
            document
                .getElementById("password")
                .setAttribute("type", "password");
            document
                .getElementById("pass-status")
                .setAttribute("class", "fa fa-eye");
        }
    }

    // Fired when component is initialized and input properties are set
    public onInit(): void {
        let autologin: any = sessionStorage.getItem("SupplierApp.autologin");
        if (autologin !== undefined && autologin !== null) {
            autologin = autologin === "1";
        }

        if (autologin) {
            this.$authenticationService
                .signIn({ userName: "", password: "" })
                .subscribe(
                    () => {
                        this.$router.navigate(["auth-callback"]);
                    },
                    (err) => {
                        sessionStorage.removeItem("SupplierApp.autologin");
                        sessionStorage.removeItem("SupplierApp.supplierName");
                    }
                );
        }
    }
    // Fired when component's views and child views are initialized
    // public onShow(): void {
    // }
    // Fired just before Angular destroys the component. Unsubscribe Observables and detach event handlers to avoid memory leaks
    // public onHide(): void {}
    public onLogin(userData: any): any {
        sessionStorage.setItem("SupplierApp.supplierName", userData.userName);
        sessionStorage.setItem("SupplierApp.autologin", "1");
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-login-form/djiv-login-form.component.ts